{
  "DATA_ASSISTANT": {
    "TITLE": "Asistenti i të dhënave",
    "NEW_CONVERSATION": "+ Re",
    "LOADING": "Duke ngarkuar...",
    "LOADING_MESSAGES": "Duke ngarkuar mesazhet...",
    "THINKING": "Duke menduar...",
    "UNTITLED": "Bisedë pa titull",
    "NO_CONVERSATIONS": "Ende nuk ka biseda. Klikoni «+ Re» për të filluar.",
    "EMPTY_STATE": "Zgjidhni një bisedë ose krijoni një të re për të filluar.",
    "PLACEHOLDER": "Çfarë mund të gjej për ju?",
    "SHOW_SQL": "Shfaq SQL",
    "NO_ROWS": "Nuk u kthye asnjë rresht.",
    "DELETE": "×",
    "DELETE_CONFIRM": "Fshi bisedën",
    "DELETE_CONFIRM_DESCRIPTION": "Jeni i sigurt që doni të fshini këtë bisedë? Ky veprim nuk mund të zhbëhet.",
    "DELETE_CONFIRM_YES": "Fshi",
    "REPORTS": "Raportet",
    "SAVE_TO_REPORT": "Ruaj në raport",
    "NEW_REPORT": "Raport i ri",
    "REPORT_NAME": "Emri i raportit",
    "NO_REPORTS": "Ende nuk ka raporte të ruajtura",
    "REPORTS_EMPTY_STATE": "Zgjidhni një raport ose krijoni një të ri.",
    "REPORT_SAVED": "U ruajt në raport",
    "DELETE_REPORT_CONFIRM": "Fshi raportin",
    "DELETE_REPORT_CONFIRM_DESCRIPTION": "Jeni i sigurt që doni të fshini këtë raport? Të gjithë elementët e ruajtur do të hiqen.",
    "DELETE_ITEM_CONFIRM": "Hiq elementin",
    "DELETE_ITEM_CONFIRM_DESCRIPTION": "Jeni i sigurt që doni ta hiqni këtë element nga raporti?",
    "EXPORT_CSV": "Eksporto CSV",
    "REFRESH": "Rifresko",
    "QUERY_RUNNING": "Duke ekzekutuar pyetjen...",
    "QUERY_FAILED": "Pyetja dështoi",
    "AUTO_REFRESH": "Rifreskim automatik",
    "AUTO_REFRESH_NONE": "Manual",
    "AUTO_REFRESH_30S": "30 sekonda",
    "AUTO_REFRESH_1M": "1 minutë",
    "AUTO_REFRESH_5M": "5 minuta",
    "AUTO_REFRESH_10M": "10 minuta",
    "EDIT_MESSAGE": "Redakto mesazhin",
    "RENAME_REPORT": "Riemërto raportin",
    "RENAME_ITEM": "Riemërto elementin",
    "MOVE_UP": "Lëviz lart",
    "MOVE_DOWN": "Lëviz poshtë",
    "COLLABORATORS": {
      "BUTTON": "Bashkëpunëtorë",
      "TITLE": "Bashkëpunëtorët e raportit",
      "DESCRIPTION": "Zgjidhni cilët agjentë dhe ekipe mund ta shohin këtë raport.",
      "AGENTS": "Agjentët",
      "TEAMS": "Ekipet",
      "SELECT_AGENTS": "Zgjidhni agjentët",
      "SELECT_TEAMS": "Zgjidhni ekipet",
      "SAVE": "Ruaj",
      "SAVED": "Bashkëpunëtorët u përditësuan",
      "SAVE_FAILED": "Përditësimi i bashkëpunëtorëve dështoi"
    }
  }
}
